// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DatabaseFilledSvg from "@ant-design/icons-svg/es/asn/DatabaseFilled";
import AntdIcon from '../components/AntdIcon';

var DatabaseFilled = function DatabaseFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseFilledSvg
  }));
};

DatabaseFilled.displayName = 'DatabaseFilled';
export default React.forwardRef(DatabaseFilled);